"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const node_fetch_1 = require("node-fetch");
const querystring_1 = require("querystring");
const utils_1 = require("./utils");
const HOST = 'https://service-bqvg4bkz-1251316161.bj.apigw.tencentcs.com';
const API_MAP = {
    sts: HOST + '/sts',
    setdown: HOST + '/setdown',
    pickup: HOST + '/pickup'
};
let FileShelf = /** @class */ (() => {
    class FileShelf {
        constructor(options) {
            utils_1.assertArgument(options, 'appKey');
            utils_1.assertArgument(options, 'appId');
            this.options = options;
            this.filePrefix = FileShelf.NAMESPACE + '/' + this.options.appId;
            this.cosInstance = this.buildCos();
        }
        // 存件
        setdown(options) {
            return node_fetch_1.default(API_MAP.setdown, {
                method: 'POST',
                body: querystring_1.stringify({
                    paths: JSON.stringify(options.paths),
                    expireInterval: options.expireInterval || 0,
                    secretId: this.options.appId,
                    secretKey: this.options.appKey
                }),
                headers: {
                    'content-type': 'application/x-www-form-urlencoded'
                }
            })
                .then(res => res.json())
                .then(utils_1.fetchSuccess);
        }
        // 取件
        pickup(options) {
            const code = [].concat(options.code);
            if (!code.length) {
                return null;
            }
            return node_fetch_1.default(API_MAP.pickup, {
                method: 'POST',
                body: querystring_1.stringify(Object.assign(Object.assign({}, options), { code })),
                headers: {
                    'content-type': 'application/x-www-form-urlencoded'
                }
            })
                .then(res => res.json())
                .then(utils_1.fetchSuccess);
        }
        static createAuthorization(appId, appKey) {
            return function getAuthorization(options, cb) {
                FileShelf.getSts(Object.assign(Object.assign({}, options), { appId,
                    appKey })).then(({ credentials, expiredTime }) => {
                    cb({
                        TmpSecretId: credentials.tmpSecretId,
                        TmpSecretKey: credentials.tmpSecretKey,
                        XCosSecurityToken: credentials.sessionToken,
                        ExpiredTime: expiredTime,
                        // 细粒度控制权限需要设为 true，会限制密钥只在相同请求时重复使用
                        ScopeLimit: true
                    });
                });
            };
        }
        static getSts(options) {
            return node_fetch_1.default(API_MAP.sts, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: querystring_1.stringify(Object.assign({ secretId: options.appId, secretKey: options.appKey }, options))
            })
                .then(res => res.json())
                .then(utils_1.fetchSuccess);
        }
    }
    FileShelf.BUSKET = 'mbcbasic-1251316161';
    FileShelf.REGION = 'ap-beijing';
    FileShelf.NAMESPACE = 'fileshelf';
    FileShelf.API_MAP = API_MAP;
    return FileShelf;
})();
exports.default = FileShelf;
//# sourceMappingURL=FileShelf.js.map